export enum AuthState {
    FORCE_RESET = "resetPassword",
    LOGIN = "signIn",
    REGISTER = "signUp"
}
